export enum AlertEnum {
  info,
  success,
  warn,
  error
}
